import { Observable, ObservableInput, empty, of } from 'rxjs'
import { AjaxError } from 'rxjs/ajax'
import { Action } from 'actions'
import { isExpectedError, processError } from 'helpers/ajaxHelpers'
import { catchError } from 'rxjs/operators'
import { setUnexpectedErrorActionCreator } from 'actions/globalActions'
import { getErrorType, isAjaxError } from 'helpers/errorHelpers'

/**
 * @deprecated Use ajaxCatch instead
 * */
export const catchSafe = <T, R>(selector?: (err: any, caught: Observable<T>) => ObservableInput<R>) => (source: Observable<T>) => {
  return source.pipe(
    catchError((error: AjaxError) => {
      if (isExpectedError(error)) {
        return processError(error)
      }

      if (selector) {
        return selector(error, empty())
      }

      return of(setUnexpectedErrorActionCreator(getErrorType(error), error))
    })
  ) as Observable<R | Action>
}

/**
 * @deprecated Use ajaxCatch instead
 * */
export const catchAjaxSafe = <T, R> (unexpectedAjaxHandler: (err: AjaxError) => Observable<R | Action>) => (source: Observable<T>) => {
  return source.pipe(
    catchSafe((error: AjaxError) => {
      if (isAjaxError(error)) {
        return unexpectedAjaxHandler(error)
      }

      return processError(error)
    })
  ) as Observable<R | Action>
}
